module.exports = __webpack_public_path__ + "media/images/training_case10-f07f63eb37d52dcc96a81629ea67bc91.jpg";